import { useEffect, useState } from 'react';
import { Toaster, toast } from 'sonner';
import { SalePage } from '@/pages/SalePage';
import { OnboardingPage } from '@/pages/OnboardingPage';
import { LoginGate } from '@/components/LoginGate';
import { connector } from '@/lib/auth';

export function App() {
  const isOnboarding =
    typeof window !== 'undefined' &&
    (window.location.pathname.startsWith('/onboarding') ||
      window.location.search.includes('token='));

  const [hasSession, setHasSession] = useState<boolean>(() => connector.getCurrentUser() !== null);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = 'MiBodega POS';
    }
  }, []);

  if (isOnboarding) {
    return (
      <>
        <OnboardingPage />
        <Toaster position="top-right" />
      </>
    );
  }

  async function handleLogout() {
    await connector.logout();
    setHasSession(false);
    toast.success('Sesión cerrada');
  }

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-neutral-50">
      <main className="flex min-h-0 flex-1 flex-col">
        {hasSession ? (
          <SalePage onLogout={handleLogout} />
        ) : (
          <LoginGate
            onLogin={() => {
              setHasSession(true);
            }}
          />
        )}
      </main>

      <Toaster position="top-right" />
    </div>
  );
}
